import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_GET_SEARCHED_PRODUCTS } from "../modals/Constants";
import HeaderView from "../other-components/HeaderView/view";
import ContainerV1Modal from "../containerModals/ContainerV1/modal";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import FooterView from "../other-components/FooterView/view";

function Search() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const query = searchParams.get("q") || "";
  const searchedFor = searchParams.get("d") || "";
  const isLinked = searchParams.get("linked") === "true";
  const searchedDescription = !isLinked || !searchedFor.trim() ? query : searchedFor;

  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [resultFound, setResultFound] = useState(true);
  const [isPaginationAvailable, setPagination] = useState(false);

  const [pageConst, setConstants] = useState({
    showHeadSearch: true,
    isShowFooter: true,
    isLoadingShow: false,
    searchedResults: [],
    categoryList: [],
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = e.target[0].value.trim();
    if (value !== "") {
      navigate("/search?q=" + value, { replace: true });
      setPageNumber(1);
      setConstants((prev) => ({ ...prev, searchedResults: [] }));
    }
  };

  const loadMoreProduct = () => {
    setPageNumber((prev) => prev + 1);
  };

  useEffect(() => {
    if (!query) return;

    const searchProducts = async () => {
      setLoading(true);
      try {
        const formData = { SEARCHED: query, PAGE: pageNumber, LINKED: isLinked };
        const res = await fetch(API_GET_SEARCHED_PRODUCTS, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          setResultFound(true);
          setPagination(data.pagination);
          setConstants((prev) => ({
            ...prev,
            searchedResults: [...prev.searchedResults, ...data.data],
          }));
        } else if (pageNumber === 1) {
          setResultFound(false);
        }
      } catch (err) {
        setLoading(false);
      }
    };

    searchProducts();
  }, [query, pageNumber, isLinked]);

  return (
    <div className={general.appView}>
      <LoadingDialog isOpen={loading} />

      <div className={general.appChildView}>
        <HeaderView categories={pageConst.categoryList} screen={"search"} />

        <div className={general.appLocationViews}>
          {searchedDescription ? <p>Searched: {searchedDescription}</p> : <p>Search</p>}

        </div>

        <div className={[general.appContentsView, screen.searchView].join(" ")}>
          <form className={general.w100} onSubmit={handleSubmit}>
            <div>
              <div className={general.inpBoxOutline}>
                <input
                  type="text"
                  placeholder="Search by product, category or collection"
                  autoComplete="off"
                />
              </div>
            </div>
          </form>

          <div className={[general.w100, general.mgT20px].join(" ")}>
            <ContainerV1Modal data={pageConst.searchedResults} />
            {!resultFound ?
              <div className={screen.noResultView}>No result found</div>
              : null}
          </div>

          {isPaginationAvailable && (
            <div className={[general.w100, general.viewCenter, general.mgT20px].join(" ")}>
              <button
                className={[general.primaryBtn, general.rounded1x].join(" ")}
                onClick={loadMoreProduct}
              >
                Load More
              </button>
            </div>
          )}
        </div>

        <FooterView />
      </div>
    </div>
  );
}

export default Search;